// extracted by mini-css-extract-plugin
export default {"retour":"page_retour__-QjWo","wrapper":"page_wrapper__ocY+W"};